/**
 * Copyright 2019, OpenCensus Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as webTypes from '@opencensus/web-types';
import { randomTraceId } from '../../common/id-util';
import { Span } from './span';
/** Simple mock root span for use in use tests. */
var RootSpan = /** @class */ (function (_super) {
    __extends(RootSpan, _super);
    function RootSpan(
    /** Trace associated with this root span. */
    tracer, 
    /** A trace options object to build the root span. */
    context) {
        var _this = _super.call(this) || this;
        _this.tracer = tracer;
        if (context) {
            _this.name = context.name;
            _this.kind = context.kind || webTypes.SpanKind.UNSPECIFIED;
            var spanContext = context.spanContext;
            if (spanContext) {
                _this.parentSpanId = spanContext.spanId || '';
                _this.traceId = spanContext.traceId;
                _this.traceState = spanContext.traceState || '';
            }
        }
        else {
            _this.traceId = randomTraceId();
        }
        return _this;
    }
    RootSpan.prototype.start = function () {
        _super.prototype.start.call(this);
        this.tracer.onStartSpan(this);
    };
    RootSpan.prototype.end = function () {
        _super.prototype.end.call(this);
        this.tracer.onEndSpan(this);
    };
    return RootSpan;
}(Span));
export { RootSpan };
//# sourceMappingURL=root-span.js.map